<div class="unlock-modal">
  <div class="unlock-hero">
    <span class="unlock-emoji">🏕️</span>
    <h2>Nuevas insignias desbloqueadas</h2>
    <p>Has mejorado tu rango Scout. Sigue así.</p>
  </div>

  <div class="unlock-list">
    @for (badge of data.badges; track badge.id) {
      <div
        class="unlock-item"
        [class.unlock-item--bronze]="badge.tier === 'bronze'"
        [class.unlock-item--silver]="badge.tier === 'silver'"
        [class.unlock-item--gold]="badge.tier === 'gold'"
      >
        <span class="unlock-icon">{{ badge.icon }}</span>
        <div class="unlock-copy">
          <span class="unlock-title">{{ badge.title }}</span>
          <span class="unlock-desc">{{ badge.description }}</span>
        </div>
        <button
          mat-icon-button
          type="button"
          aria-label="Compartir insignia"
          (click)="share(badge)"
        >
          <mat-icon>ios_share</mat-icon>
        </button>
      </div>
    }
  </div>

  <div mat-dialog-actions class="unlock-actions">
    <button mat-stroked-button class="secondary-btn" (click)="dialogRef.close()">
      Seguir jugando
    </button>
    <button mat-flat-button class="primary-btn" (click)="dialogRef.close('open-book')">
      Ver Libro Scout
    </button>
  </div>
</div>
